<template>
    <div>
        <DataTable :value="records" :lazy="true" :paginator="true" :rows="10" ref="dt" dataKey="id"
            :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" @filter="onFilter($event)"
            :scrollable="true" scrollHeight="500px" :rowHover="true" showGridLines :class="['p-datatable--web']" :filters="filters">
            <template #empty>
                No Web results found.
            </template>

            <template #loading>
                Loading Web data. Please wait.
            </template>

            <Column field="title" header="Title"></Column>

            <Column field="domain" header="Domain"></Column>

            <Column field="rank_absolute" header="Rank Absolute"></Column>

            <Column field="url" header="URL">
                <template #body="{ data }">
                    <a :href="data.url" target="_blank">{{ data.url }}</a>
                </template>
            </Column>


            <!-- <Column header="Screenshots">
                <template #body="{ data }">
                    <button v-if="data.loading == true" class="btn dekonstruktor__web-results-btn">
                        LOADING...
                    </button>
                    <a v-else-if="data.screenshot" :href="data.screenshot" target="_blank" class="btn dekonstruktor__web-results-btn">
                        VIEW
                    </a>
                    <button v-else @click="() => {setLoading(data)}" class="btn dekonstruktor__web-results-btn">
                       CHECK FOR SCREENSHOT
                    </button>
                </template>
            </Column> -->
        </DataTable>

        <template v-if="totalRecords > 0">
            <div class="creator-search-results__accordion-copy" style="text-align: center">
                {{ totalRecords }} Web Results Found
            </div>
        </template>
        <template v-if="props.hitsTotal > 0">
            <div class="creator-search-results__accordion-copy" style="text-align: center">
                {{ props.hitsTotal.toLocaleString() }} Organic Google hits on the web
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ApiMixin from "../../mixins/apiMixin";
// import axios from 'axios';

const props = defineProps(['searchToken', 'hitsTotal']);

const dt = ref();
const lazyParams = ref({});
const loading = ref(false);
const totalRecords = ref(0);
const records = ref(null);

const filters = ref({
    text: {
        value: '',
        matchMode: 'isEmpty'
    }
})

onMounted(async () => {
    lazyParams.value = {
        first: 0,
        rows: dt.value.rows
    };

    await loadLazyData();
});

async function onPage(event) {
    lazyParams.value = event;
    await loadLazyData();
}

async function loadLazyData() {
    loading.value = true;
    const result = await ApiMixin.methods.webSearchPaginate(props.searchToken, lazyParams.value);

    // EMPTY RECORD SET OR AN ERROR OCCURRED.
    if (!result) {
        records.value = [];
        totalRecords.value = 0;
        loading.value = false;
        return false;
    }

    result.data.results.map((item) => {
        item.loading = false;
        return item;
    })

    records.value = result.data.results;

    totalRecords.value = result.data.totalRecords;
    loading.value = false;
}

// function setLoading(data) {

//     records.value.map((item) => {
//         item.loading = false;

//         if(item.id == data.id) {
//             item.loading = true;
//             return item;
//         }

//         return item;
//     })

//     getScreenShot(data);
// }

// function getScreenShot(data) {


//     records.value.map(async (item) => {
//         if(item.id == data.id) {
//             let screenshot = await axios.get(`${process.env.VUE_APP_API_ROOT_URL}/api/web-screenshot/`+data.id)
//             item.screenshot = screenshot.data.screenshot
//             item.loading = false;
//         }

//         return item;
//     })
// }

</script>